import { IUserDto, useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { AuthenticationGetPermissions, AuthenticationGetPermissionsResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<AuthenticationGetPermissionsResponse, AuthenticationGetPermissionsResponse>) => {
    return response?.data?.permissions ?? []
}
const getError = (response?: SWRResponse<AuthenticationGetPermissionsResponse, AuthenticationGetPermissionsResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const usePermissions = (user?: IUserDto, configuration?: SWRConfiguration<AuthenticationGetPermissionsResponse, AuthenticationGetPermissionsResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new AuthenticationGetPermissions();
        };
    }, [user])

    return useGet(request, { getData, getError }, configuration);
}

export default usePermissions;